var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlarnaWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 120",
    style: {
      enableBackground: "new 0 0 200 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FC81A0;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rounded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Large",
    transform: "translate(-32.000000, -1156.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "large_x2F_klarna-1",
    transform: "translate(32.000000, 1156.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Background",
    className: "st0",
    d: "M8,0h184c4.4,0,8,3.6,8,8v104c0,4.4-3.6,8-8,8H8c-4.4,0-8-3.6-8-8V8C0,3.6,3.6,0,8,0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(24.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "klarna"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st1",
    d: "M28.2,0h-7.9c0,6.5-3,12.4-8.1,16.2L9,18.6L21.1,35H31L19.9,19.9C25.2,14.6,28.2,7.6,28.2,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    y: 0,
    className: "st1",
    width: 8.1,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path_00000103947533306401045020000010431725430811150494_",
    x: 33.4,
    y: 0,
    className: "st1",
    width: 7.6,
    height: 35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000158727408078148183380000006965184944769807292_",
    className: "st1",
    d: "M107.6,10.1c-2.9,0-5.7,0.9-7.5,3.4v-2.7 h-7.2V35h7.3V22.3c0-3.7,2.5-5.5,5.4-5.5c3.2,0,5,1.9,5,5.4V35h7.2V19.6C117.9,14,113.4,10.1,107.6,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000013886222484926488570000000526271931709372554_",
    className: "st1",
    d: "M63.9,10.8v1.6c-2-1.4-4.5-2.2-7.2-2.2 c-7.1,0-12.8,5.7-12.8,12.8s5.7,12.8,12.8,12.8c2.7,0,5.2-0.8,7.2-2.2V35h7.2V10.8H63.9z M57.3,29.1c-3.6,0-6.6-2.8-6.6-6.2 s2.9-6.2,6.6-6.2c3.6,0,6.6,2.8,6.6,6.2S61,29.1,57.3,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000163764204302735733120000017372312505476380558_",
    className: "st1",
    d: "M82.4,13.9v-3.1H75V35h7.5V23.7 c0-3.8,4.1-5.9,7-5.9c0,0,0.1,0,0.1,0v-7.1C86.6,10.8,83.8,12.1,82.4,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000096753388418283920510000012464711651869874836_",
    className: "st1",
    d: "M140.4,10.8v1.6c-2-1.4-4.5-2.2-7.2-2.2 c-7.1,0-12.8,5.7-12.8,12.8s5.7,12.8,12.8,12.8c2.7,0,5.2-0.8,7.2-2.2V35h7.2V10.8H140.4z M133.8,29.1c-3.6,0-6.6-2.8-6.6-6.2 s2.9-6.2,6.6-6.2s6.6,2.8,6.6,6.2C140.4,26.3,137.5,29.1,133.8,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000002350118798912038730000006153943240633381761_",
    className: "st1",
    d: "M153.3,11.5c0-0.4-0.2-0.6-0.6-0.6H152 v1.8h0.3v-0.7h0.4l0.3,0.7h0.4L153,12C153.2,11.9,153.3,11.8,153.3,11.5z M152.7,11.8h-0.4v-0.6h0.4c0.2,0,0.3,0.1,0.3,0.3 S152.9,11.8,152.7,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000134955899770256599260000005025970510562864297_",
    className: "st1",
    d: "M152.5,10.2c-1,0-1.7,0.8-1.7,1.7 c0,1,0.8,1.7,1.7,1.7c1,0,1.7-0.8,1.7-1.7C154.3,10.9,153.5,10.2,152.5,10.2z M152.5,13.3c-0.8,0-1.4-0.6-1.4-1.4 c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4C153.9,12.7,153.3,13.3,152.5,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000010277111795258251650000011192985433285756568_",
    className: "st1",
    d: "M155.4,26.4c-2.5,0-4.6,2-4.6,4.6 s2,4.6,4.6,4.6c2.5,0,4.6-2,4.6-4.6C160,28.4,157.9,26.4,155.4,26.4z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlarnaWhite);
export default __webpack_public_path__ + "static/media/klarna-white.dbfd509f97026d6835276c560ed9db99.svg";
export { ForwardRef as ReactComponent };